/**
 * Ce qu'un champ déclare au système pour que celui-ci propose de le remplir : le bon clavier, le
 * contenu attendu (`textContentType` parle à iOS, `autoComplete` à Android et au web), et pas de
 * majuscule ni de correction sur une adresse ou un mot de passe.
 *
 * Un champ étale son préréglage — `<TextInput {...textInputAutofill.email} … />` — au lieu de
 * réécrire ces cinq props : un champ qui en oublie une perd le remplissage sans que rien ne le dise.
 */
import { type TextInputProps } from "./TextInput"

export const textInputAutofill = {
    email: {
        keyboardType: "email-address",
        textContentType: "emailAddress",
        autoComplete: "email",
        autoCapitalize: "none",
        autoCorrect: false,
    },
    phone: {
        keyboardType: "phone-pad",
        textContentType: "telephoneNumber",
        autoComplete: "tel",
    },
    /** Le mot de passe d'un compte : le gestionnaire propose celui qu'il connaît. */
    currentPassword: {
        secureTextEntry: true,
        textContentType: "password",
        autoComplete: "current-password",
        autoCapitalize: "none",
        autoCorrect: false,
    },
    /** Un mot de passe qu'on choisit : le gestionnaire propose d'en créer un, pas l'ancien. */
    newPassword: {
        secureTextEntry: true,
        textContentType: "newPassword",
        autoComplete: "new-password",
        autoCapitalize: "none",
        autoCorrect: false,
    },
} as const satisfies Record<string, Partial<TextInputProps>>
